var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrag = function SvgDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 5.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 1 1-3.5 0ZM13 5.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 1 1-3.5 0ZM7.5 18.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 1 1-3.5 0ZM13 18.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 1 1-3.5 0ZM7.5 11.9a1.75 1.75 0 1 1 3.5 0v.1a1.75 1.75 0 1 1-3.5 0v-.1ZM13 11.9a1.75 1.75 0 1 1 3.5 0v.1a1.75 1.75 0 1 1-3.5 0v-.1Z"
  })));
};
export default SvgDrag;